import { flow } from 'fp-ts/lib/function';
import { iso } from 'newtype-ts';
import { match } from 'ts-pattern';
// provides ability to wrap, unwrap, and modify the newtype
const _ = iso();
// export functions from here
export const create = _.wrap;
export const createMeters = (value) => _.wrap({ value, unit: 'metre' });
export const meters = flow(_.unwrap, ({ unit, value }) => match(unit)
    .with('metre', () => value)
    .with('centimetre', () => value / 100)
    .with('millimetre', () => value / 1000)
    .exhaustive());
export const centimetres = flow(_.unwrap, ({ unit, value }) => match(unit)
    .with('centimetre', () => value)
    .with('metre', () => value * 100)
    .with('millimetre', () => value / 10)
    .exhaustive());
export const millimetres = flow(_.unwrap, ({ unit, value }) => match(unit)
    .with('millimetre', () => value)
    .with('centimetre', () => value * 10)
    .with('metre', () => value * 1000)
    .exhaustive());
